exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n[data-v-5b225143] .hl {\n  background-color: yellow;\n}\n", "", {"version":3,"sources":["/Users/junya/sunnyeee/sciseed/sAIFaqAdmin/src/components/Highlight.vue"],"names":[],"mappings":";AACA;EACE,yBAAyB;CAC1B","file":"Highlight.vue","sourcesContent":["\n[data-v-5b225143] .hl {\n  background-color: yellow;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5b225143","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Highlight.vue
// module id = mXnt
// module chunks = 0